export const emptyNotificationAnimation = {
  path: 'assets/animations/empty-3.json',
  loop: true
};
